
import { defineComponent } from 'vue'
import TimelineV2 from '../Common/TimelineV2.vue'

export default defineComponent({
  name: 'DummyAuditLog',
  components: { TimelineV2 },
  data() {
    return {
      dummyAuditLog: [
        {
          id: '11',
          eventName: 'jedi.change_role',
          description: "Role of the user Duck Norris (duck@quackotron.com) was changed to 'admin'.",
          ipAddress: '127.0.0.1',
          location: 'Quackotron',
          createdAt: '2023-02-24T08:15:24.207960+00:00',
          actor: {
            id: 'norris-deepsource',
            fullName: 'Duck Norris',
            firstName: 'Duck',
            email: 'duck@quackotron.com',
            avatar:
              'https://local-asgard-static.s3.us-east-1.amazonaws.com/dashboard/images/empty-avatar.svg'
          }
        },
        {
          id: '12',
          eventName: 'jedi.remove',
          description: 'User Bug Invader (bug@invaders.bug) was removed from team.',
          ipAddress: '127.0.0.1',
          location: 'Quackotron',
          createdAt: '2023-02-24T08:15:24.207960+00:00',
          actor: {
            id: 'bug-invader',
            fullName: 'Bug Invader',
            firstName: 'Bug',
            email: 'bug@invaders.bug',
            avatar:
              'https://local-asgard-static.s3.us-east-1.amazonaws.com/dashboard/images/empty-avatar.svg'
          }
        },
        {
          id: '13',
          eventName: 'jedi.change_role',
          description:
            "Role of the user Duck Norris (duck@quackotron.com) was changed to 'member'.",
          ipAddress: '127.0.0.1',
          location: 'Quackotron',
          createdAt: '2023-02-24T08:15:24.207960+00:00',
          actor: {
            id: 'norris-deepsource',
            fullName: 'Duck Norris',
            firstName: 'Duck',
            email: 'duck@quackotron.com',
            avatar:
              'https://local-asgard-static.s3.us-east-1.amazonaws.com/dashboard/images/empty-avatar.svg'
          }
        }
      ]
    }
  }
})
